var _excluded = ["transformElement"],
  _excluded2 = ["element", "contentType"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES, BLOCKS, MARKS } from '@contentful/rich-text-types';
import { renderContentfulComponent } from '../../utils/contentful';
import LinkGenerator from '../link-generator';
import Quote from '../quote';
import Table from '../table';
require("./rich-text.css");
var styles = {
  "richText": "richText-2p9V4",
  "richTextUnorderedList": "richTextUnorderedList-1BB54",
  "richTextParagraph": "richTextParagraph-3luMk",
  "richTextOrderedList": "richTextOrderedList-bC-F2",
  "richTextListItem": "richTextListItem-3U9gc",
  "richTextLink": "richTextLink-PmsAW",
  "richTextBlockquote": "richTextBlockquote-UjpE3",
  "richTextProductCarousel": "richTextProductCarousel-2mqWs"
}; // render embedded entry for type `block` or `inline`
var renderEmbeddedEntry = (node, links, options, type) => {
  var _links$entries$type;
  var contentfulComponent =
  // if links is provided then search for the component there (graphql response type)
  (links === null || links === void 0 ? void 0 : (_links$entries$type = links.entries[type]) === null || _links$entries$type === void 0 ? void 0 : _links$entries$type.find(entry => entry.sys.id === node.data.target.sys.id)) ||
  // otherwise the target directly contains the component (REST response type)
  node.data.target;
  return renderContentfulComponent({
    contentfulComponent,
    options
  });
};
var getOptions = (links, options) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => /*#__PURE__*/React.createElement("p", {
      className: cs(styles.richTextParagraph, 'lll-text-body-1')
    }, children),
    [BLOCKS.UL_LIST]: (_, children) => /*#__PURE__*/React.createElement("ul", {
      className: styles.richTextUnorderedList
    }, children),
    [BLOCKS.OL_LIST]: (_, children) => /*#__PURE__*/React.createElement("ol", {
      className: styles.richTextOrderedList
    }, children),
    [BLOCKS.LIST_ITEM]: (_, children) => /*#__PURE__*/React.createElement("li", {
      className: styles.richTextListItem
    }, children),
    [BLOCKS.TABLE]: (_, children) => {
      var headings = [];
      var rows = [];
      // Contenful rich text table returns a complete nested entries with td, th, etc.
      // We have to extract the content from these entries so we can plug it into our existing table component.
      // Not doing so would render an unstyled table
      for (var rowNode of children) {
        var isHeaderRow = rowNode.props.children[0].type === 'th';
        var rowChildren = rowNode.props.children;
        var rowData = [];
        // extract the values from contenful provided table components
        for (var i = 0; i < rowChildren.length; i++) {
          var slotContent = rowChildren[i].props.children[0].props.children[0];
          rowData.push({
            value: slotContent
          });
        }
        // please see table/Readme.md to understand data structure for headings and rows
        if (isHeaderRow) {
          headings = rowData;
        } else {
          rows.push(rowData);
        }
      }
      return /*#__PURE__*/React.createElement(Table, {
        columnHeading: headings,
        rows: rows
      });
    },
    [BLOCKS.HEADING_2]: (_, children) => /*#__PURE__*/React.createElement("h2", {
      className: "lll-text-medium"
    }, children),
    [BLOCKS.HEADING_3]: (_, children) => /*#__PURE__*/React.createElement("h3", {
      className: "lll-text-small"
    }, children),
    [BLOCKS.HEADING_4]: (_, children) => /*#__PURE__*/React.createElement("h4", {
      className: "lll-text-xsmall"
    }, children),
    [INLINES.HYPERLINK]: (node, children) => /*#__PURE__*/React.createElement(LinkGenerator, {
      className: cs(styles.richTextLink),
      href: node.data.uri
    }, children),
    [BLOCKS.QUOTE]: (_, children) => /*#__PURE__*/React.createElement(Quote, {
      className: styles.richTextBlockquote
    }, children),
    [BLOCKS.EMBEDDED_ENTRY]: node => renderEmbeddedEntry(node, links, options, 'block'),
    [INLINES.EMBEDDED_ENTRY]: node => renderEmbeddedEntry(node, links, options, 'inline')
  },
  renderMark: {
    [MARKS.BOLD]: text => /*#__PURE__*/React.createElement("strong", null, text),
    [MARKS.ITALIC]: text => /*#__PURE__*/React.createElement("em", null, text)
  }
});
var RichText = _ref => {
  var {
      body,
      options: {
        transformElement: initialTransformElement
      } = {},
      className
    } = _ref,
    initialOptions = _objectWithoutProperties(_ref.options, _excluded);
  if (!body) return null;
  var {
    json,
    links
  } = body;
  var options = _objectSpread(_objectSpread({}, initialOptions), {}, {
    transformElement: _ref2 => {
      var {
          element,
          contentType
        } = _ref2,
        otherTransformParams = _objectWithoutProperties(_ref2, _excluded2);
      var transformedElement = element;
      // provide custom props for embedded entries here
      if (contentType === 'productCarousel') {
        transformedElement = /*#__PURE__*/React.cloneElement(element, {
          className: cs(element.props.className, styles.richTextProductCarousel)
        });
      }

      // apply any existing passed in transformations
      if (initialTransformElement) {
        transformedElement = initialTransformElement(_objectSpread({
          element: transformedElement,
          contentType
        }, otherTransformParams));
      }
      return transformedElement;
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.richText, className)
  }, documentToReactComponents(json || body, getOptions(links, options)));
};
RichText.propTypes = {
  /** Response from Contentful's rich text field */
  body: PropTypes.oneOfType([/** REST API style response */
  PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape({
      nodeType: PropTypes.string,
      content: PropTypes.array,
      data: PropTypes.object
    })).isRequired
  }), /** GraphQL style response */
  PropTypes.shape({
    json: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.shape({
        nodeType: PropTypes.string,
        content: PropTypes.array,
        data: PropTypes.object
      })).isRequired
    }),
    links: PropTypes.shape({
      entries: PropTypes.shape({
        inline: PropTypes.arrayOf(PropTypes.shape({
          sys: PropTypes.shape({
            id: PropTypes.string.isRequired
          }).isRequired
        })),
        block: PropTypes.arrayOf(PropTypes.shape({
          sys: PropTypes.shape({
            id: PropTypes.string.isRequired
          }).isRequired
        }))
      })
    })
  })]).isRequired,
  /** options for calling renderContentfulComponent on embedded entries */
  options: PropTypes.shape({
    /** dictionary of render functions */
    renderContentType: PropTypes.object,
    transformElement: PropTypes.func
  }),
  className: PropTypes.string
};
RichText.defaultProps = {
  options: {},
  className: ''
};
export default RichText;